import type { AssignedTaskDTO } from "../api/client";
import { taskUrgencyForTask } from "./taskUrgency";

function prioritySortRank(p: AssignedTaskDTO["priority"]): number {
  if (p === "high") return 0;
  if (p === "medium") return 1;
  if (p === "low") return 2;
  return 3;
}

/** ລຽງຕາມຄວາມສຳຄັນ (ສູງ → ຕ່ຳ → ບໍ່ກຳນົດ), ຈາກນັ້ນຕາມຮີບດ່ວນ/ວັນຄົບ */
export function sortTasksByPriority(
  rows: AssignedTaskDTO[],
): AssignedTaskDTO[] {
  const urgencyRank = (t: AssignedTaskDTO) => {
    const u = taskUrgencyForTask(t);
    if (t.status === "done") return 3;
    if (u === "overdue") return 0;
    if (u === "due_soon") return 1;
    return 2;
  };
  return [...rows].sort((a, b) => {
    const pa = prioritySortRank(a.priority);
    const pb = prioritySortRank(b.priority);
    if (pa !== pb) return pa - pb;
    const ra = urgencyRank(a);
    const rb = urgencyRank(b);
    if (ra !== rb) return ra - rb;
    const da = a.dueDate ? Date.parse(a.dueDate) : 0;
    const db = b.dueDate ? Date.parse(b.dueDate) : 0;
    if (da !== db) return da - db;
    return a.title.localeCompare(b.title);
  });
}

/** ລຽງຕາມຮີບດ່ວນ (ເກີນກຳນົດ/ໃກ້ຄົບກ່ອນ) — ບໍ່ອີງຄວາມສຳຄັນ DB */
export function sortTasksByUrgency(rows: AssignedTaskDTO[]): AssignedTaskDTO[] {
  const rank = (t: AssignedTaskDTO) => {
    const u = taskUrgencyForTask(t);
    if (t.status === "done") return 3;
    if (u === "overdue") return 0;
    if (u === "due_soon") return 1;
    return 2;
  };
  return [...rows].sort((a, b) => {
    const ra = rank(a);
    const rb = rank(b);
    if (ra !== rb) return ra - rb;
    const da = a.dueDate ? Date.parse(a.dueDate) : 0;
    const db = b.dueDate ? Date.parse(b.dueDate) : 0;
    if (da !== db) return da - db;
    return a.title.localeCompare(b.title);
  });
}

/** ຄ່າດົນກັບ sortBy=alertStatus ຝັ່ງ API */
export function sortTasksByAlertStatus(
  rows: AssignedTaskDTO[],
): AssignedTaskDTO[] {
  const rank = (t: AssignedTaskDTO) =>
    t.alertStatus === "overdue" ? 2 : t.alertStatus === "due_soon" ? 1 : 0;
  return [...rows].sort((a, b) => {
    const diff = rank(b) - rank(a);
    if (diff !== 0) return diff;
    const da = a.dueDate ? Date.parse(a.dueDate) : Number.POSITIVE_INFINITY;
    const db = b.dueDate ? Date.parse(b.dueDate) : Number.POSITIVE_INFINITY;
    return da - db;
  });
}

export function sortTasksByDueDate(
  rows: AssignedTaskDTO[],
  order: "asc" | "desc",
): AssignedTaskDTO[] {
  return [...rows].sort((a, b) => {
    const da = a.dueDate
      ? Date.parse(a.dueDate)
      : order === "asc"
        ? Number.POSITIVE_INFINITY
        : 0;
    const db = b.dueDate
      ? Date.parse(b.dueDate)
      : order === "asc"
        ? Number.POSITIVE_INFINITY
        : 0;
    if (da !== db) return order === "asc" ? da - db : db - da;
    return a.title.localeCompare(b.title);
  });
}
